import type { BISettings } from '@wix/ricos';
import type { useBi } from '@wix/yoshi-flow-editor';

export const tpaBISettings: (
  defaultParams: any,
  logger: ReturnType<typeof useBi>,
) => BISettings = (defaultParams, logger) => ({
  consumer: 'TPA Example',
  platform: 'Livesite',
  usage: 'DemoTPA',
  contentId: '1234',
  postId: 'demo-post-id',
  containerId: '3e1dc7e8-3444-45ba-a54b-884466c7da0e',
  defaultParams,
  logger,
  biCallbacks: {
    onPublish: (contentId, plugins_count, plugins_details, version) =>
      console.log('TPA publish hook', {
        contentId,
        plugins_count,
        plugins_details,
        version,
      }),
  },
});
